var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPlayFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.376 12.416L8.777 19.482C8.70171 19.5321 8.61423 19.5609 8.52389 19.5652C8.43355 19.5695 8.34373 19.5492 8.264 19.5065C8.18427 19.4639 8.1176 19.4003 8.07111 19.3228C8.02462 19.2452 8.00005 19.1564 8 19.066V4.93401C8.00005 4.84356 8.02462 4.75483 8.07111 4.67725C8.1176 4.59967 8.18427 4.53616 8.264 4.49347C8.34373 4.45078 8.43355 4.43051 8.52389 4.43484C8.61423 4.43916 8.70171 4.4679 8.777 4.51801L19.376 11.584C19.4445 11.6297 19.5006 11.6915 19.5395 11.7641C19.5783 11.8367 19.5986 11.9177 19.5986 12C19.5986 12.0823 19.5783 12.1633 19.5395 12.2359C19.5006 12.3085 19.4445 12.3703 19.376 12.416Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play-fill.11ed5d9cbbb3b3d4c3bc4b63991921e3.svg";